(ns renolit-roofing-service.layout.advanced-tooltip
  (:require ["react" :as react]
            ["@floating-ui/react" :as floating-ui]
            [goog.object :as g]
            [renolit-roofing-service.util :as util]))

(defn use-interactions
  [context {:keys [hover focus dismiss role click list-navigation typeahead]}]
  (let [use-interactions
        (floating-ui/useInteractions
         (clj->js
          (cond-> []
            hover
            (conj (floating-ui/useHover context (clj->js hover)))

            focus
            (conj (floating-ui/useFocus context (clj->js focus)))

            dismiss
            (conj (floating-ui/useDismiss context (clj->js dismiss)))

            role
            (conj (floating-ui/useRole context (clj->js role)))

            click
            (conj (floating-ui/useClick context (clj->js click)))

            list-navigation
            (conj (floating-ui/useListNavigation context (clj->js list-navigation)))

            typeahead
            (conj (floating-ui/useTypeahead context (clj->js typeahead))))))]
    {:reference-props (js->clj (.getReferenceProps use-interactions))
     :floating-props (js->clj (.getFloatingProps use-interactions))
     :interactions use-interactions}))

(defn use-floating
  [opts]
  (let [use-floating (floating-ui/useFloating (clj->js opts))]
    {:refs (g/getValueByKeys use-floating "refs")
     :style (g/getValueByKeys use-floating "floatingStyles")
     :context (g/getValueByKeys use-floating "context")}))

(defn dont-overflow-max-available-height
  [opts]
  (let [available-height (- (g/getValueByKeys opts "availableHeight") 20)
        floating (g/getValueByKeys opts "elements" "floating")
        scroll-height (g/getValueByKeys floating "scrollHeight")]
    (set! (.-height (.-style floating))
          (str (min available-height scroll-height) "px"))))

(defn advanced-tooltip
  [{:keys [reference floating interactions middlewares arrow]}]
  (let [[is-open set-open] (react/useState false)
        arrow-ref (react/useRef nil)
        {:keys [refs style context]}
        (use-floating
         {:open is-open
          :onOpenChange (fn [state]
                          (util/execute-callback
                           (if state
                             (:on-open floating)
                             (:on-close floating)))
                          (set-open state))
          :whileElementsMounted floating-ui/autoUpdate
          :placement (get floating :placement "bottom")
          :strategy (get floating :strategy "absolute")
          :middleware (cond-> [(floating-ui/offset 10)
                               (floating-ui/flip)
                               (floating-ui/shift)
                               (floating-ui/arrow #js {:element arrow-ref})]
                        (:size middlewares)
                        (conj (floating-ui/size (clj->js (:size middlewares)))))})
        interactions (merge {:focus {}
                             :dismiss {}
                             :hover {:move false
                                     :handleClose (floating-ui/safePolygon)}
                             :role {:role "tooltip"}}
                            interactions)
        {:keys [floating-props reference-props]}
        (use-interactions context interactions)]
    [:<>
     [(:component reference)
      (merge
       reference-props
       {:ref #(.setReference refs %)})
      (:args reference)
      {:set-open-fn set-open}]
     (when is-open
       [(:component floating)
        (merge
         floating-props
         {:ref #(.setFloating refs %)
          :style style})
        [:> floating-ui/FloatingArrow
         (merge
          {:ref arrow-ref
           :context context}
          (when (:class arrow)
            {:class (:class arrow)}))]
        (:args floating)
        {:set-open-fn set-open}])]))
